import {styled} from "styled-components";
import {Image} from "antd";

export const StyledImage = styled(Image)`
    border-radius: 15px;
     height: 100px;
`;